import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
export class zfctt {
    static replaceImage() {
        if ($(window).outerWidth() <= 720) {
            $(".zfctt-teaser .zfctt-mobile-image").each(function () {
                $(this).attr("src", $(this).data("src"));
                $(this)
                    .find(".zfctt-text")
                    .css({ "max-height": "" });
            });
        }
        else {
            $(".zfctt-teaser .zfctt-image").each(function () {
                $(this).attr("src", $(this).data("src"));
            });
        }
    }
    ;
    static loadImage(img) {
        img.find('.zfctt-image[data-src]').attr("src", img.find('.zfctt-image').data("src"));
        img.find('.zfctt-mobile-image[data-src]').attr("src", img.find('.zfctt-mobile-image').data("src"));
        return true;
    }
    ;
    static setImages(teasers) {
        $(teasers).find(".zfctt-teaser")
            .each(function () {
            var that = $(this);
            var thatImage = that.find(".zfctt-image");
            var thatImageName = thatImage.data("image-name");
            var newImage;
            if (thatImageName != undefined) {
                if (zfc.window.width() > 720) {
                    if (that.hasClass("zfctt-teaser-s")) {
                        newImage = thatImage.data('image-1-1') ? thatImage.data('image-1-1') : zfUtils.replaceLast(".", "_1_1_422px.", thatImageName);
                    }
                    else if (that.hasClass("zfctt-teaser-m") || that.hasClass("zfctt-item-block-product")) {
                        newImage = thatImage.data('image-3-2') ? thatImage.data('image-3-2') : zfUtils.replaceLast(".", "_3_2_748px.", thatImageName);
                    }
                    else if (that.hasClass("zfctt-teaser-l")) {
                        newImage = thatImage.data('image-2-1') ? thatImage.data('image-2-1') : zfUtils.replaceLast(".", "_2_1_820px.", thatImageName);
                    }
                    else if (that.hasClass("zfctt-teaser-xs")) {
                        newImage = thatImage.data('image-16-9') ? thatImage.data('image-16-9').replace("FirstSpirit749x499WebP", "FirstSpirit1920x1080WebP") : zfUtils.replaceLast(".", "_Widescreen169.", thatImageName);
                    }
                }
                else {
                    newImage = thatImage.data('image-3-2') ? thatImage.data('image-3-2') : zfUtils.replaceLast(".", "_3_2_748px.", thatImageName);
                }
                thatImage.attr("data-src", newImage);
                zfUtils.loadOnScroll(that, "delayZFCTTLoad", zfctt.loadImage, 1);
            }
        });
    }
    ;
    static teaserHoverIn() {
        if ($(window).outerWidth() > 960) {
            var that = $(this);
            if (that.closest(".zfctt-teaser-social").length) {
                return;
            }
            that.find(".zfctt-text").css("max-height", "unset");
            var v = {
                containerHeight: that.outerHeight(),
                containerWidth: that.outerWidth(),
                text: (that.find(".zfctt-text").length ? that.find(".zfctt-text")[0].scrollHeight : 0),
                maxHeight: 0,
                maxWidth: 0,
            };
            that.find(".zfctt-text").css("max-height", 0);
            v.maxHeight = v.containerHeight;
            v.maxWidth = v.containerWidth;
            if (v.text > 0) {
                that.find(".zfctt-category").finish();
                that.find(".zfctt-category").fadeOut(150);
            }
            that.find(".zfctt-text, .zfctt-content-bg, .zfctt-content").finish();
            that.find(".zfctt-text").animate({ "min-height": v.text }, { duration: 500, queue: false });
            that.find(".zfctt-content-bg, .zfctt-content").animate({ "min-height": v.maxHeight, "min-width": v.maxWidth }, { duration: 500, queue: false, });
        }
    }
    ;
    static teaserHoverOut() {
        if ($(window).outerWidth() > 960) {
            var that = $(this);
            that.find(".zfctt-text, .zfctt-content-bg, .zfctt-content").finish();
            that.find(".zfctt-text, .zfctt-content-bg, .zfctt-content").animate({ "min-height": 0, "min-width": 0 }, { duration: 500, queue: false });
            that.find(".zfctt-category").finish();
            that.find(".zfctt-category").fadeIn();
        }
    }
    ;
    static adjustIframe(that) {
        $(that).height(that.clientWidth / 4 * 3);
    }
    ;
    static sortTeaserTile(teaser) {
        var _I = $(teaser).find(".zfctt-item-wrapper .zfctt-item");
        for (var i = 0; i < _I.length; i++) {
            _I[i].teaserType = _I.eq(i).hasClass("zfctt-teaser-s")
                ? _I.eq(i).hasClass("zfctt-teaser-social")
                    ? "S"
                    : "s"
                : _I.eq(i).hasClass("zfctt-teaser-m")
                    ? "m"
                    : "l";
            _I[i].teaserSorted = false;
        }
        function startSort() {
            var sortType, skip;
            var sortedItems = 0;
            var restItems = [];
            var restItemsSize = 0;
            var lastStartSort;
            for (var i = 0; i < _I.length; i++) {
                if (_I[i].teaserSorted === true) {
                    continue;
                }
                if (!_I[i + 1] || !_I[i + 2]) {
                    restItems.push(_I[i]);
                    if (_I[i].teaserType.toLowerCase() === "s") {
                        restItemsSize += 1;
                    }
                    else if (_I[i].teaserType === "m") {
                        restItemsSize += 1.5;
                    }
                    else {
                        restItemsSize += 2;
                    }
                }
                else {
                    sortType =
                        _I[i].teaserType + _I[i + 1].teaserType + _I[i + 2].teaserType;
                    skip = filterElements[sortType](_I[i], _I[i + 1], _I[i + 2], i, _I);
                    sortedItems = sortedItems + 1 + skip;
                    lastStartSort = _I[i];
                }
            }
            alignMisfits(restItems, restItemsSize, (sortedItems - 1));
        }
        function alignMisfits(items, itemsSize, lastSorted) {
            if (itemsSize === 3) {
                return;
            }
            else if (itemsSize === 4) {
                $(items[0])
                    .removeClass("zfctt-teaser-l")
                    .addClass("zfctt-teaser-m");
                $(items[1])
                    .removeClass("zfctt-teaser-l")
                    .addClass("zfctt-teaser-m");
                items[0].teaserType = "m";
                items[1].teaserType = "m";
            }
            else if (itemsSize === 3.5) {
                if (items[0].teaserType === "m") {
                    $(items[1])
                        .removeClass("zfctt-teaser-l")
                        .addClass("zfctt-teaser-m");
                    items[1].teaserType = "m";
                }
                else {
                    $(items[0])
                        .removeClass("zfctt-teaser-l")
                        .addClass("zfctt-teaser-m");
                    items[0].teaserType = "m";
                }
            }
            else if (itemsSize === 2) {
                if (items.length > 1) {
                    if (items[0].teaserType === "s") {
                        $(items[0])
                            .removeClass("zfctt-teaser-s")
                            .addClass("zfctt-teaser-l");
                        $(items[0]).find('.zfctt-text').data("text-limit", 500).data();
                        $(items[0]).find('.zfctt-text').attr('data-text-limit', 500);
                        items[0].teaserType = "l";
                    }
                    else if (items[1].teaserType === "s") {
                        $(items[1])
                            .removeClass("zfctt-teaser-s")
                            .addClass("zfctt-teaser-l");
                        $(items[1]).find('.zfctt-text').data("text-limit", 500).data();
                        $(items[1]).find('.zfctt-text').attr('data-text-limit', 500);
                        items[1].teaserType = "l";
                    }
                    else {
                        handleMisfits(items, lastSorted, true);
                    }
                }
                else {
                    handleMisfits(items, lastSorted, false);
                }
            }
            else {
                handleMisfits(items, lastSorted, false);
            }
            function handleMisfits(items, lastSorted, twoSocials) {
                if (twoSocials) {
                    var mediumTeasers = $(".zfctt-item-wrapper .zfctt-item.zfctt-teaser-m").get().reverse();
                    if (mediumTeasers.length >= 2) {
                        $(mediumTeasers[0]).removeClass('zfctt-teaser-m').addClass('zfctt-teaser-l');
                        mediumTeasers[0].teaserType = 'l';
                        $(items[0]).insertAfter($(mediumTeasers[0]));
                        $(mediumTeasers[1]).removeClass('zfctt-teaser-m').addClass('zfctt-teaser-l');
                        mediumTeasers[1].teaserType = 'l';
                        $(items[1]).insertBefore($(mediumTeasers[1]));
                        return;
                    }
                }
                var type, skip = 0, fitted;
                items.forEach(function (el) {
                    for (var i = lastSorted; i > 0; i--) {
                        if (skip > 0) {
                            skip = skip - 1;
                            continue;
                        }
                        skip = 2;
                        type = _I[i - 1].teaserType + _I[i].teaserType;
                        if (alignMisfitElements[type]) {
                            alignMisfitElements[type](_I[i - 1], _I[i], el);
                            break;
                        }
                        else {
                            if (el.teaserType !== "S") {
                                if (itemsSize < 2) {
                                    fitted = false;
                                    if (tryEnlargeSmallTeaser(_I[i - 2])) {
                                        $(el).insertAfter($(_I[i]));
                                        $(el)
                                            .removeClass("zfctt-teaser-m zfctt-teaser-s")
                                            .addClass("zfctt-teaser-l");
                                        $(el).find('.zfctt-text').data("text-limit", 500).data();
                                        $(el).find('.zfctt-text').attr('data-text-limit', 500);
                                        el.teaserType = "l";
                                        fitted = true;
                                    }
                                    else if (tryEnlargeSmallTeaser(_I[i - 1])) {
                                        $(el).insertAfter($(_I[i - 1]));
                                        $(el)
                                            .removeClass("zfctt-teaser-s zfctt-teaser-l")
                                            .addClass("zfctt-teaser-m");
                                        $(el).find('.zfctt-text').data("text-limit", 500).data();
                                        $(el).find('.zfctt-text').attr('data-text-limit', 500);
                                        el.teaserType = "m";
                                        fitted = true;
                                    }
                                    else if (tryEnlargeSmallTeaser(_I[i])) {
                                        $(_I[i]).insertAfter($($(_I[i - 2])));
                                        $(el).insertAfter($(_I[i]));
                                        $(el)
                                            .removeClass("zfctt-teaser-m zfctt-teaser-s")
                                            .addClass("zfctt-teaser-l");
                                        $(el).find('.zfctt-text').data("text-limit", 500).data();
                                        $(el).find('.zfctt-text').attr('data-text-limit', 500);
                                        el.teaserType = "s";
                                        fitted = true;
                                    }
                                    if (fitted) {
                                        break;
                                    }
                                }
                                skip += 1;
                            }
                        }
                    }
                });
            }
        }
        function tryEnlargeSmallTeaser(el) {
            if (el.teaserType !== "S") {
                $(el)
                    .removeClass("zfctt-teaser-s")
                    .addClass("zfctt-teaser-l");
                $(el).find('.zfctt-text').data("text-limit", 500).data();
                $(el).find('.zfctt-text').attr('data-text-limit', 500);
                el.teaserType = "l";
                return true;
            }
            return false;
        }
        function tryMediumizeSmallTeaser(el) {
            if (el.teaserType !== "S") {
                $(el)
                    .removeClass("zfctt-teaser-s")
                    .addClass("zfctt-teaser-m");
                $(el).find('.zfctt-text').data("text-limit", 500).data();
                $(el).find('.zfctt-text').attr('data-text-limit', 500);
                el.teaserType = "m";
                return true;
            }
            return false;
        }
        var filterElements = {
            isFitting: function (a, b, c, index, list) {
                a.teaserSorted = true;
                b.teaserSorted = true;
                return 1;
            },
            sss: function (a, b, c, index, list) {
                a.teaserSorted = true;
                b.teaserSorted = true;
                c.teaserSorted = true;
                return 2;
            },
            ssm: function (a, b, c, index, list) {
                $(c)
                    .removeClass("zfctt-teaser-m")
                    .addClass("zfctt-teaser-s");
                $(c).find('.zfctt-text').data("text-limit", 300).data();
                $(c).find('.zfctt-text').attr('data-text-limit', 300);
                c.teaserType = "s";
                a.teaserSorted = true;
                b.teaserSorted = true;
                c.teaserSorted = true;
                return 2;
            },
            sms: function (a, b, c, index, list) {
                $(b)
                    .removeClass("zfctt-teaser-m")
                    .addClass("zfctt-teaser-l");
                b.teaserType = "l";
                a.teaserSorted = true;
                b.teaserSorted = true;
                return 1;
            },
            ssl: function (a, b, c, index, list) {
                $(c)
                    .removeClass("zfctt-teaser-l")
                    .addClass("zfctt-teaser-s");
                $(c).find('.zfctt-text').data("text-limit", 300).data();
                $(c).find('.zfctt-text').attr('data-text-limit', 300);
                c.teaserType = "s";
                a.teaserSorted = true;
                b.teaserSorted = true;
                c.teaserSorted = true;
                return 2;
            },
            smm: function (a, b, c, index, list) {
                $(b)
                    .removeClass("zfctt-teaser-m")
                    .addClass("zfctt-teaser-l");
                b.teaserType = "l";
                a.teaserSorted = true;
                b.teaserSorted = true;
                return 1;
            },
            mss: function (a, b, c, index, list) {
                $(a)
                    .removeClass("zfctt-teaser-m")
                    .addClass("zfctt-teaser-l");
                a.teaserType = "l";
                a.teaserSorted = true;
                b.teaserSorted = true;
                return 1;
            },
            mls: function (a, b, c, index, list) {
                $(a)
                    .removeClass("zfctt-teaser-m")
                    .addClass("zfctt-teaser-s");
                a.teaserType = "s";
                a.teaserSorted = true;
                b.teaserSorted = true;
                return 1;
            },
            lls: function (a, b, c, index, list) {
                $(a)
                    .removeClass("zfctt-teaser-l")
                    .addClass("zfctt-teaser-m");
                $(b)
                    .removeClass("zfctt-teaser-l")
                    .addClass("zfctt-teaser-m");
                a.teaserType = "m";
                b.teaserType = "m";
                a.teaserSorted = true;
                b.teaserSorted = true;
                return 1;
            },
            lms: function (a, b, c, index, list) {
                $(b)
                    .removeClass("zfctt-teaser-m")
                    .addClass("zfctt-teaser-s");
                $(b).find('.zfctt-text').data("text-limit", 300).data();
                $(b).find('.zfctt-text').attr('data-text-limit', 300);
                b.teaserType = "s";
                a.teaserSorted = true;
                b.teaserSorted = true;
                return 1;
            }
        };
        filterElements["sll"] = filterElements["isFitting"];
        filterElements["sls"] = filterElements["isFitting"];
        filterElements["slm"] = filterElements["isFitting"];
        filterElements["Slm"] = filterElements["isFitting"];
        filterElements["lss"] = filterElements["isFitting"];
        filterElements["lsl"] = filterElements["isFitting"];
        filterElements["lsm"] = filterElements["isFitting"];
        filterElements["mms"] = filterElements["isFitting"];
        filterElements["mmm"] = filterElements["isFitting"];
        filterElements["mml"] = filterElements["isFitting"];
        filterElements["sml"] = filterElements["smm"];
        filterElements["Sml"] = filterElements["smm"];
        filterElements["msl"] = filterElements["mss"];
        filterElements["msm"] = filterElements["mss"];
        filterElements["lll"] = filterElements["lls"];
        filterElements["llm"] = filterElements["lls"];
        filterElements["lmm"] = filterElements["lms"];
        filterElements["lml"] = filterElements["lms"];
        filterElements["mll"] = filterElements["mls"];
        filterElements["mlm"] = filterElements["mls"];
        filterElements["llS"] = filterElements["lls"];
        filterElements["ssS"] = filterElements["sss"];
        filterElements["sSs"] = filterElements["sss"];
        filterElements["sSS"] = filterElements["sss"];
        filterElements["Sss"] = filterElements["sss"];
        filterElements["SsS"] = filterElements["sss"];
        filterElements["SSs"] = filterElements["sss"];
        filterElements["SSS"] = filterElements["sss"];
        filterElements["sSm"] = filterElements["ssm"];
        filterElements["SSm"] = filterElements["ssm"];
        filterElements["Ssm"] = filterElements["ssm"];
        filterElements["SSl"] = filterElements["ssl"];
        filterElements["Ssl"] = filterElements["ssl"];
        filterElements["sSl"] = filterElements["ssl"];
        filterElements["slS"] = filterElements["sls"];
        filterElements["SlS"] = filterElements["sls"];
        filterElements["Sls"] = filterElements["sls"];
        filterElements["Smm"] = filterElements["smm"];
        filterElements["SmS"] = filterElements["sms"];
        filterElements["smS"] = filterElements["sms"];
        filterElements["Sms"] = filterElements["sms"];
        filterElements["Sll"] = filterElements["sll"];
        filterElements["mSS"] = filterElements["mss"];
        filterElements["msS"] = filterElements["mss"];
        filterElements["mSs"] = filterElements["mss"];
        filterElements["mss"] = filterElements["mss"];
        filterElements["mSm"] = filterElements["mss"];
        filterElements["mSl"] = filterElements["msl"];
        filterElements["mlS"] = filterElements["mls"];
        filterElements["mmS"] = filterElements["mms"];
        filterElements["lsS"] = filterElements["lss"];
        filterElements["lSS"] = filterElements["lss"];
        filterElements["lSs"] = filterElements["lss"];
        filterElements["lSm"] = filterElements["lsm"];
        filterElements["lSl"] = filterElements["lsl"];
        filterElements["lmS"] = filterElements["lms"];
        var alignMisfitElements = {
            ls: function (a, b, target) {
                $(target)
                    .removeClass("zfctt-teaser-l")
                    .addClass("zfctt-teaser-s");
                $(a)
                    .removeClass("zfctt-teaser-l")
                    .addClass("zfctt-teaser-s");
                target.teaserType = "s";
                a.teaserType = "s";
                target.teaserSorted = true;
                return true;
            },
            lS: function () { },
            sl: function (a, b, target) {
                $(target)
                    .removeClass("zfctt-teaser-l")
                    .addClass("zfctt-teaser-s");
                $(b)
                    .removeClass("zfctt-teaser-l")
                    .addClass("zfctt-teaser-s");
                target.teaserType = "s";
                b.teaserType = "s";
                target.teaserSorted = true;
                return true;
            },
            Sl: function () { },
            mm: function (a, b, target) {
                $(target)
                    .removeClass("zfctt-teaser-l zfctt-teaser-m")
                    .addClass("zfctt-teaser-s");
                $(a)
                    .removeClass("zfctt-teaser-m")
                    .addClass("zfctt-teaser-s");
                $(b)
                    .removeClass("zfctt-teaser-m")
                    .addClass("zfctt-teaser-s");
                target.teaserType = "s";
                a.teaserType = "s";
                b.teaserType = "s";
                target.teaserSorted = true;
                return true;
            }
        };
        alignMisfitElements["lS"] = alignMisfitElements["ls"];
        alignMisfitElements["Sl"] = alignMisfitElements["sl"];
        startSort();
    }
    ;
    static revertCroppedText() {
        var that = $(this);
        that.html(that.html().trim().replace('<div class="zfc-cropped-text">', '')
            .replace('<span class="zfc-cropped-text-dots">...</span>', '')
            .replace('<span class="zfc-cropped-text-rest">', '')
            .replace('</span></div>', '')
            .replace('<span class="zfc-show-more-link-tag"><span class="zfc-show-more-link-text">Read more</span><span class="zfc-show-more-link-icon zfcui-icon zfcui-icon-arrow-big-thin-d" role="button"></span></span>', ''));
    }
    ;
    static replaceWithExtraSmall(className, item) {
        var textLen = window.location.href.indexOf('customers.zf.com') > 0 ? 150 : 50;
        $(item).removeClass(className).addClass("zfctt-teaser-xs");
        $(item).find('.zfctt-headline').data("text-limit", textLen).data();
        $(item).find('.zfctt-headline').attr('data-text-limit', textLen);
        $(item).find('.zfctt-text').data("text-limit", 150).data();
        $(item).find('.zfctt-text').attr('data-text-limit', 150);
        if ($('.zf-webedit').length > 0 && $(item).find('.zfc-cropping-res-div:first').data("fs-resolution") != "Widescreen169") {
            $(item).find('.zfc-cropping-res-div').remove();
            $("<div>Switch this teaser type to 'Teaser XS' for cropping options</div>").insertAfter($(item).find(".zfctt-content"));
        }
    }
    ;
    static init() {
        try {
            $(".zfctt-teasers").not(".zfctt-no-resize").each(function (index, teaser) {
                zfctt.sortTeaserTile(teaser);
                if ($(teaser).find(".zfctt-teaser-xs").length == 0) {
                    $(teaser).find('[data-text-limit]').each(zfctt.revertCroppedText);
                    $(teaser).find('[data-text-limit]').each(zfc.limitText);
                }
            });
            $(".zfctt-teasers").each(function (index, teaser) {
                if ($(teaser).prev().hasClass("zfctt-teasers")) {
                    $(teaser).addClass("zfctt-merge");
                }
                if ($(teaser).find(".zfctt-teaser-xs").length > 0) {
                    $(teaser).find('[data-text-limit]').each(zfctt.revertCroppedText);
                    $(teaser).find(".zfctt-item").each(function (index, item) {
                        if ($(item).hasClass("zfctt-teaser-s")) {
                            zfctt.replaceWithExtraSmall("zfctt-teaser-s", item);
                        }
                        else if ($(item).hasClass("zfctt-teaser-m")) {
                            zfctt.replaceWithExtraSmall("zfctt-teaser-m", item);
                        }
                        else if ($(item).hasClass("zfctt-teaser-l")) {
                            zfctt.replaceWithExtraSmall("zfctt-teaser-l", item);
                        }
                    });
                    $(teaser).find('[data-text-limit]').each(zfc.limitText);
                }
                zfctt.setImages(teaser);
            });
            if (zfctt.resizeKey !== null) {
                zfUtils.offResize(zfctt.resizeKey);
            }
            zfctt.resizeKey = zfUtils.onResize(function () {
                $(".youtubeIframe").each(zfctt.adjustIframe);
            });
            $(".youtubeIframe")
                .off("load.zfctt")
                .on("load.zfctt", zfctt.adjustIframe);
            $(".zfctt-teasers .zfctt-text").each(function () {
                if ($(this).text().trim().length != 0) {
                    $(this)
                        .closest(".zfctt-teaser .zfctt-item-block")
                        .off("mouseenter.zfctt mouseleave.zfctt")
                        .on("mouseenter.zfctt", zfctt.teaserHoverIn)
                        .on("mouseleave.zfctt", zfctt.teaserHoverOut);
                }
            });
        }
        catch (err) {
            console.log("Initalization failed: zfctt.init() " + err.message);
        }
    }
}
zfctt.imageFormat = ".jpg";
zfctt.resizeKey = null;
;
try {
    zfUtils.onReady(zfctt.init);
}
catch (err) {
    console.log("Initalization failed: zfctt.init() " + err.message);
}
